<template>
  <div>
    <!-- 编辑 -->
    <el-drawer
      title="活动详情"
      :visible.sync="visible"
      direction="rtl"
      :before-close="handleClose"
      custom-class="c-drawer"
      :wrapperClosable="false"
      size="65%"
    >
      <div class="drawer-content">
        <el-form
          :model="dataForm"
          :rules="dataRule"
          ref="dataForm"
          label-width="110px"
          v-loading="loading"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="title">
                <el-input v-model="dataForm.title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动类型" prop="cubeType">
                <el-select v-model="dataForm.cubeType" style="width: 100%">
                  <el-option
                    v-for="item in cubeTypeOptions"
                    :key="item.paraValue"
                    :label="item.paraName"
                    :value="item.paraValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="优惠券" prop="couponId">
                <el-select
                  v-model="dataForm.couponId"
                  style="width: 100%"
                  filterable
                  placeholder="请选择优惠券"
                >
                  <el-option
                    v-for="item in couponList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发放数量" prop="quantity">
                <el-input-number
                  style="width: 100%;"
                  v-model="dataForm.quantity"
                  controls-position="right"
                  clearable
                  :min="1"
                  @change="handleNumChange(scope)"
                  @keydown.enter.prevent
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动页面" prop="page">
                <el-input v-model="dataForm.page"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动状态" prop="status">
                <el-select v-model="dataForm.status" style="width: 100%">
                  <el-option
                    v-for="item in activityStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动开始时间" prop="startTime">
                <el-date-picker
                  v-model="dataForm.startTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动结束时间" prop="endTime">
                <el-date-picker
                  v-model="dataForm.endTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="活动介绍" prop="content">
                <div id="editor"></div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="" prop="channels">
                <div id="tweetPictures">
                  <div class="faultClass container">
                    <h4>投放渠道</h4>
                    <ul class="clearfix" style="overflow-y:auto">
                      <li
                        v-for="(item, index) in channelItems"
                        :key="index"
                        class="faultClassListPart listPart"
                      >
                        {{ item.title }}
                        <span class="exitBtn" @click.stop="editChannel(item)"
                          >编辑</span
                        >
                        <i
                          class="el-icon-error activeDelBtn"
                          @click="deleteChannel(item)"
                        ></i>
                      </li>
                      <li class="addContent" @click.stop="addChannel({})">
                        <i class="el-icon-plus"></i>
                      </li>
                    </ul>
                  </div>
                  <biz-channel-info
                    ref="infoRef"
                    @refresh="renewInfo"
                  ></biz-channel-info>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="drawer-footer">
        <div class="operation">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="dataFormSubmit()">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { couponListApi } from "@/api/coupon";
import {
  getActivityInfoApi,
  saveActivityInfoApi,
  delActivityChannelApi
} from "@/api/activity";
import BizChannelInfo from "./info.vue";
import E from "wangeditor";

const nanoid = require("nanoid/generate");
export default {
  name: "activityEdit",
  components: {
    BizChannelInfo
  },
  data() {
    return {
      editor: undefined,
      visible: false,
      dataForm: { channelList: [] },
      dataRule: {
        title: [
          { required: true, message: "活动名称不能为空", trigger: "blur" }
        ],
        cubeType: [
          { required: true, message: "活动类型不能为空", trigger: "change" }
        ],
        couponId: [
          { required: true, message: "优惠券不能为空", trigger: "change" }
        ],
        quantity: [
          { required: true, message: "发放数量不能为空", trigger: "change" }
        ],
        status: [
          { required: true, message: "活动状态不能为空", trigger: "change" }
        ],
        startTime: [
          { required: true, message: "活动开始时间不能为空", trigger: "blur" }
        ],
        endTime: [
          {
            // 不允许与开始时间相同
            validator: (rule, value, callback) => {
              console.log(value, this.dataForm.startTime);
              if (value && value < this.dataForm.startTime) {
                callback(new Error("结束时间必须大于开始时间"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      couponList: [],
      cubeTypeOptions: [],
      activityStatusOptions: [],
      tmpFlag: "",
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  created() {
    this.loadCouponList();
  },
  mounted() {},
  methods: {
    /**
     * 发放数量修改
     */
    handleNumChange(val) {
      const isNUm = val.row.num;
      if (!Number.isInteger(isNUm)) {
        this.$modal.msgError("发放数量必须是正整数");
        return;
      }
    },
    loadCouponList() {
      couponListApi().then(res => {
        if (res.data.status == 100) {
          this.couponList = res.data.results;
        }
      });
    },
    createEditor() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.editor = new E("#editor");
      this.editor.config.zIndex = 0;
      this.editor.create();
    },
    open(id, options) {
      this.tmpFlag = nanoid("1234567890abcdef", 10);

      this.cubeTypeOptions = options.cubeTypeOptions;
      this.activityStatusOptions = options.activityStatusOptions;

      this.visible = true;

      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.dataForm = { channelList: [] };
        this.loading = false;
        this.createEditor();
      });
      if (id) {
        this.getActivityInfo(id);
      }
    },
    getActivityInfo(id) {
      this.loading = true;
      getActivityInfoApi(id)
        .then(res => {
          if (res.data.status == 100) {
            this.dataForm = res.data.results;
            if (this.editor) {
              this.editor.txt.html(this.dataForm.descriptionHtml);
            }
          } else {
            this.$message({
              message: res.data.message
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      if (this.editor) {
        this.editor.destroy();
      }
      this.visible = false;
    },
    getFormData() {
      const data = this.dataForm;
      data.descriptionHtml = this.editor.txt.html();
      data.description = this.editor.txt.text();
      return data;
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.saveData();
        }
      });
    },
    saveData() {
      let _self = this;
      const data = { ...this.getFormData(), tmpFlag: this.tmpFlag };
      this.loading = true;
      saveActivityInfoApi(data)
        .then(res => {
          if (res.data.status == 100) {
            _self.$message({
              message: res.data.message,
              type: "success"
            });
            _self.handleClose();
            _self.$emit("refreshDataList");
          } else {
            _self.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //>>>--------------------------------------------------------------------------------------------------------------
    addChannel(item) {
      this.$refs.infoRef.open({
        tmpFlag: this.tmpFlag,
        code: nanoid("1234567890abcdef", 10),
        page: this.dataForm.page,
        isNew: true,
        activityId: this.dataForm.id
      });
    },
    editChannel(item) {
      this.$refs.infoRef.open({
        ...item,
        isNew: false
      });
    },
    deleteChannel(item) {
      this.$confirm("确认删除该渠道?", "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {
          this._deleteChannel(item);
        })
        .catch(() => {});
    },
    _deleteChannel(item) {
      this.loading = true;
      delActivityChannelApi(item.id)
        .then(res => {
          if (res.data.status == 100) {
            const channel = this.dataForm.channelList.find(
              channel => channel.code === item.code
            );
            channel.status = "0";
          } else {
            this.$message({
              message: res.data.message
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    renewInfo(item) {
      if (item.isNew) {
        this.dataForm.channelList.push({
          id: item.id,
          code: item.code,
          title: item.title,
          status: "1",
          image: item.image
        });
      } else {
        const channel = this.dataForm.channelList.find(
          channel => channel.code === item.code
        );
        channel.title = item.title;
      }
    }
    //<<<--------------------------------------------------------------------------------------------------------------
  },
  computed: {
    channelItems() {
      if (this.dataForm.channelList && this.dataForm.channelList.length) {
        return this.dataForm.channelList.filter(item => item.status == "1");
      } else {
        return [];
      }
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
#tweetPictures {
  .clearfix {
    clear: both;
    // overflow: hidden;
    overflow: auto;
    max-height: 1024px;
  }
  .container {
    h4 {
      font-weight: 500;
      font-size: 16px;
    }
    .listPart {
      width: 160px;
      float: left;
      border: 1px solid #10c55b;
      margin: 0 15px 10px 0;
      border-radius: 10px;
      min-height: 40px;
      line-height: 1.8;
      padding: 20px 0 40px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
      font-size: 13px;
      & > span:first-child {
        display: none;
      }
      p {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.8;
        text-align: center;
        font-size: 13px;
      }
      span.active {
        position: absolute;
        top: -1px;
        right: -1px;
        display: block;
        width: 30px;
        height: 30px;
        border-width: 16px;
        border-style: solid;
        border-color: #1abc9c #1abc9c #fff #fff;
        border-top-right-radius: 10px;
        i {
          position: absolute;
          font-size: 14px;
          color: #fff;
          top: -9px;
        }
      }
      span.exitBtn {
        position: absolute;
        bottom: 0;
        width: 100%;
        line-height: 20px;
        left: 0;
        border-top: 1px solid #10c55b;
        z-index: 1;
        display: block;
        background-color: #d7ffe8;
        border-radius: 0 0 10px 10px;
        color: #10c55b;
      }
      span.warning {
        color: #e03b5b;
        background-color: #f8d7da;
        border-top: 1px solid #e03b5b;
      }
      i.activeDelBtn {
        display: none;
        position: absolute;
        top: 5px;
        left: 5px;
        color: #e03b5b;
      }
    }
    .warning-border {
      border: 1px solid #e03b5b;
    }

    .listPart:hover {
      box-shadow: 2px 2px 2px #c6c6c6;
    }
    .listPart:hover i.activeDelBtn {
      display: block;
    }
    .addContent {
      border: 1px dashed #c6c6c6;
      width: 50px;
      height: 50px;
      line-height: 50px;
      float: left;
      text-align: center;
      margin-top: 15px;
      cursor: pointer;
      i {
        font-size: 20px;
      }
    }
    .contentPart {
      width: 80px;
      float: left;
      border: 1px solid #c6c6c6;
      margin: 0 15px 10px 0;
      border-radius: 5px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      z-index: 0;
      cursor: pointer;
    }
    .activeContent {
      background-color: #1abc9c;
      color: #fff;
      border-color: #fff;
    }
  }
  .container:last-child {
    border-color: transparent;
  }
  .explain {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
  }
}
</style>
<style lang="scss" scoped>
.c-drawer {
  width: 100%;
  height: 100%;
  .drawer-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 16px;
    form {
      flex: 1;
    }
  }
  .editOpera-seat {
    width: 100%;
    height: 54px;
  }
  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 30;
    display: flex;
    /** 操作 靠右 */
    .operation {
      margin-left: auto;
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// activityEdit.vue?a2eba032